import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import {
  FilterBasic,
  FilterDrawer,
  FilterValues,
  FilterDrawerType,
  drawerInitialFilters,
  saveFilterUtilities,
} from '@blocs.filter';
import { DrawerProvider } from '@minecraft.drawer';
import { FilterForm } from './FilterForm';
import { useFiltersLabel } from './useFilterLabels';

const TALENT_SCOUT_FILTER_SESSION_STORAGE_KEY = 'talent-scout-filter';

export type FilterProps = {
  onFilterChange: (filter: FilterValues) => void;
};

export const Filter: FC<FilterProps> = ({ onFilterChange }) => {
  const initialFilters = useRef(drawerInitialFilters[FilterDrawerType.TalentScout]);
  const [appliedFilters, setAppliedFilters] = useState<FilterValues>(
    saveFilterUtilities.getSavedFiltersForThisSession({ storageKey: TALENT_SCOUT_FILTER_SESSION_STORAGE_KEY }) ||
      initialFilters.current
  );
  const filtersLabel = useFiltersLabel();

  useEffect(() => {
    // Trigger the onFilterChange initially to set the search results on initial load
    onFilterChange(appliedFilters);
  }, []);

  const applyFilters = useCallback(
    (filters: FilterValues) => {
      setAppliedFilters(filters);
      onFilterChange(filters);
    },
    [onFilterChange, setAppliedFilters]
  );

  return (
    <DrawerProvider>
      <FilterBasic
        withFilterDrawer
        sessionStorageKey={TALENT_SCOUT_FILTER_SESSION_STORAGE_KEY}
        showFilterSettingsButton={false}
        filtersLabel={filtersLabel}
        initialFilters={initialFilters.current}
        appliedFilters={appliedFilters}
        onFiltersChange={applyFilters}
        className="cn_mt-2 cn_w-full"
      >
        {() => <FilterForm />}
      </FilterBasic>
      <FilterDrawer
        sessionStorageKey={TALENT_SCOUT_FILTER_SESSION_STORAGE_KEY}
        type={FilterDrawerType.TalentScout}
        appliedFilters={appliedFilters}
        appliedQueryInput={{}}
        onFiltersChange={applyFilters}
        isTalentScout
      />
    </DrawerProvider>
  );
};
